import { createRoot } from "react-dom/client";

import { App } from "./components";

const rootElement = document.getElementById("root");

const root = createRoot(rootElement);
void root.render(<App />);
